<div class="w-100">
  <h1 class="head1">Device Details</h1>
</div>
<div class="row g-3 align-items-center mb-3">
  <div class="col-auto">
    <label for="inputPassword6" class="col-form-label"
      >Search By Dev EUI/Consumer ID</label
    >
  </div>
  <div class="col-3 position-relative">
    <input
      type="text"
      class="form-control"
      id="devUI"
      placeholder="Enter Dev EUI/Consumer ID"
      [(ngModel)]="devUiValue"
      #devUiInput="ngModel"
      (input)="onTextChange($event)"
      (keydown.enter)="selectDevice(devUiValue)"
      required
    />
    <div *ngIf="devUIValid" class="text-danger">
      Dev EUI/Consumer ID is required.
    </div>
    <ul
      *ngIf="deviceSuggestions.length > 0"
      class="dropdown-menu show position-absolute"
      style="z-index: 9999"
    >
      <li *ngFor="let device of deviceSuggestions">
        <a class="dropdown-item" (click)="selectDevice(device.dev_eui)">
          {{ device.dev_eui }}
        </a>
      </li>
    </ul>
  </div>
</div>

<div class="row">
  <div class="col-md-7 mb-3">
    <div class="card shadow-sm">
      <div class="row">
        <div class="col-md-5 pe-md-0">
          <div class="box-blue-fi">
            <p>Device Type</p>
            <p class="fw-600 font-15p mb-2">
              {{ deviceInfo?.DeviceType?.type }}
            </p>
            <p>Consumer ID</p>
            <p class="fw-600 font-15p mb-2">{{ deviceInfo?.consumer_id }}</p>
            <p>Dev EUI</p>
            <p class="fw-600 font-15p mb-2">{{ deviceInfo?.dev_eui }}</p>
            <p>Usage Type</p>
            <p class="fw-600 font-15p mb-2">{{ deviceInfo?.UsageType.type }}</p>
            <p>Consumer Name</p>
            <p class="fw-600 font-15p mb-2">{{ deviceInfo?.consumer_name }}</p>
            <p>Phone Number</p>
            <p class="fw-600 font-15p mb-2">
              {{
                deviceInfo?.consumer_phone
                  ? "(" + deviceInfo.consumer_phone.replace(",", ") ")
                  : ""
              }}
            </p>
            <p>Consumer Address</p>
            <p class="fw-600 font-15p mb-2">
              {{ deviceInfo?.consumer_address }}
            </p>
            <p>Commission Date</p>
            <p class="fw-600 font-15p mb-2">
              {{ commissionDate }}
            </p>
            <p>Modified Date</p>
            <p class="fw-600 font-15p mb-2">
              {{ formattedModifiedDate }}
            </p>
            <p>Gateway Details</p>
            <p class="fw-600 font-15p mb-2">
              {{ deviceInfo?.gateway_details }}
            </p>
          </div>
        </div>
        <div class="col-md-7 mb-3 px-5 px-md-3 py-4">
          <div class="row">
            <div class="col-md-6">
              <label for="inputPassword6" class="form-label">Status</label>
            </div>
            <div
              class="col-md-6"
              [ngClass]="{
                'dv-status-ok': deviceInfo?.DeviceStatus?.status == 'OK',
                'dv-status-alert':
                  deviceInfo?.DeviceStatus?.status == 'Reporting Alarm',
                'dv-status-offline':
                  deviceInfo?.DeviceStatus?.status == 'Offline',
                'text-danger':
                  deviceInfo?.DeviceStatus?.status == 'Deleted',
              }"
            >
              {{
                deviceInfo?.DeviceStatus?.status
                  ? (deviceInfo.DeviceStatus.status | uppercase)
                  : "----"
              }}
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-md-6">
              <label for="inputPassword6" class="form-label"
                >Battery Status</label
              >
            </div>
            <div
              class="col-md-6"
              [ngClass]="{
                'text-success': deviceInfo?.battery_status == 'NORMAL',
                'text-danger': deviceInfo?.battery_status == 'LOW'
              }"
            >
              {{
                deviceInfo?.battery_status ? deviceInfo.battery_status : "----"
              }}
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <label for="inputPassword6" class="form-label"
                >Cumulative Total</label
              >
            </div>
            <div class="col-md-6">
              <p class="font-15p m-0">
                {{
                  deviceInfo?.meter_reading
                    ? (deviceInfo.meter_reading | number : "1.2-2")
                    : "00.00"
                }}
                <span class="font-10p">Cubic Meter</span>
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <label for="inputPassword6" class="form-label"
                >Forward Total</label
              >
            </div>
            <div class="col-md-6">
              <p class="font-15p m-0">
                {{
                  deviceInfo?.forward_total
                    ? (deviceInfo.forward_total | number : "1.2-2")
                    : "00.00"
                }}
                <span class="font-10p">Cubic Meter</span>
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <label for="inputPassword6" class="form-label"
                >Reverse Total</label
              >
            </div>
            <div class="col-md-6">
              <p class="font-15p m-0">
                {{
                  deviceInfo?.low_flow_rate
                    ? (deviceInfo.low_flow_rate | number : "1.2-2")
                    : "----"
                }}
                <span class="font-10p">
                  {{ deviceInfo?.low_flow_rate ? "Cubic Meter" : "" }}
                </span>
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <label for="inputPassword6" class="form-label"
                >Previous Day Total</label
              >
            </div>
            <div class="col-md-6">
              <p class="font-15p m-0">
                {{
                  usageInfo?.previousday
                    ? (usageInfo.previousday | number : "1.2-2")
                    : "00.00"
                }}
                <span class="font-10p">Cubic Meter</span>
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <label for="inputPassword6" class="form-label"
                >Previous Month Total</label
              >
            </div>
            <div class="col-md-6">
              <p class="font-15p m-0">
                {{
                  usageInfo?.monthly
                    ? (usageInfo.monthly | number : "1.2-2")
                    : "00.00"
                }}
                <span class="font-10p">Cubic Meter</span>
              </p>
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-md-6">
              <label for="inputPassword6" class="form-label"
                >Today’s Total</label
              >
            </div>
            <div class="col-md-6">
              <p class="font-15p m-0">
                {{
                  usageInfo?.daily
                    ? (usageInfo.daily | number : "1.2-2")
                    : "00.00"
                }}
                <span class="font-10p">Cubic Meter</span>
              </p>
              <p class="font-10p m-0 w-100 float-start">
                <span class="float-start" style="width: 46%">
                  <img
                    *ngIf="usageInfo?.deltaConsumption < 0"
                    src="../../../../assets/images/arrow-down.png"
                    alt=""
                  />
                  <img
                    *ngIf="usageInfo?.deltaConsumption > 0"
                    src="../../../../assets/images/arrow-up.png"
                    alt=""
                  />
                  {{
                    usageInfo?.deltaConsumption
                      ? (Math.abs(usageInfo.deltaConsumption)
                          | number : "1.2-2") + " %"
                      : "00.00 %"
                  }}
                </span>
              </p>
              <span class="font-10p float-start" style="width: 54%"
                  >compared to last month average</span
                >
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <label for="inputPassword6" class="form-label">Custom Date</label>
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-md-6">
              <input
                type="text"
                bsDatepicker
                class="form-control mb-2"
                placeholder="From"
                [(ngModel)]="fromDate"
                [maxDate]="toDate ? toDate : currentDate"
                (ngModelChange)="getUsageCount(deviceId)"
                readonly
                (keydown)="preventInput($event)"
                [bsConfig]="datePickerConfig"
              />

              <input
                type="text"
                class="form-control"
                bsDatepicker
                placeholder="To"
                [(ngModel)]="toDate"
                [minDate]="fromDate || undefined"
                [maxDate]="currentDate"
                (ngModelChange)="getUsageCount(deviceId)"
                readonly
                (keydown)="preventInput($event)"
                [bsConfig]="datePickerConfig"
              />
            </div>
            <div class="col-md-6">
              <p class="font-15p">
                {{
                  usageCount?.custom
                    ? (usageCount.custom | number : "1.2-2")
                    : "00.00"
                }}
                <span class="font-10p">Cubic Litres</span>
              </p>
              <button
                [disabled]="!(fromDate && toDate)"
                class="btn btn-primary-sa btn-sm"
                (click)="
                  exportCustomDateWaterConsumption(deviceInfo?.consumer_id)
                "
              >
                Export
              </button>
            </div>
            <!--<div class="col-md-6 pt-4 mt-1">
              <p class="font-15p m-0">
                {{
                  usageCount?.custom
                    ? (usageCount.custom | number : "1.2-2")
                    : "00.00"
                }}
                <span class="font-10p">Cubic Meter</span>
              </p>
            </div>-->
          </div>
          <div class="row">
            <div class="col-md-6">
              <label for="inputPassword6" class="form-label">Alerts</label>
            </div>
            <div class="col-md-6">
              <p class="font-15p m-0">
                <!--<span
                  class="text-decoration-underline"
                  id="downloadFile"
                  (click)="
                    downloadDeviceAlerts(
                      deviceInfo.id.toString(),
                      deviceInfo.dev_eui.toString()
                    )
                  "
                  >{{
                    deviceInfo?.total_alerts ? deviceInfo.total_alerts : "0"
                  }}</span
                >-->
                @if (deviceInfo?.total_alerts) {
                <a
                  class="text-decoration-underline"
                  [routerLink]="['/alert', deviceInfo?.consumer_id, 'details']"
                  >{{
                    deviceInfo?.total_alerts ? deviceInfo.total_alerts : "0"
                  }}</a
                >
                } @else {
                <span class="text-decoration-underline" id="downloadFile">{{
                  deviceInfo?.total_alerts ? deviceInfo.total_alerts : "0"
                }}</span>

                }
                <span class="font-10p ms-2">History</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-5 mb-3">
    <div class="card p-3">
      <p>Device Location</p>
      <div class="map-container">
        <div class="map-frame">
          <div id="map" style="height: 325px"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-12 mb-3">
    <div class="card p-3">
      <p>Water Consumption</p>
      <div class="filter-wrap mt-2">
        @if(deviceId) {
        <div class="mx-auto d-table">
          <div class="filter-item">
            <label class="col-form-label">Period</label>
            <select
              name="period"
              id=""
              class="form-select"
              [(ngModel)]="chartFilter.period"
              (change)="$event.stopPropagation(); onPeriodChange()"
            >
              <option value="">Select</option>
              <option value="Daily">Dates</option>
              <option value="Monthly">Monthly</option>
              <option value="Yearly">Yearly</option>
            </select>
          </div>
          @if(chartFilter.period) {
          <div class="filter-item">
            <label class="col-form-label">From</label>
            <input
              type="text"
              bsDatepicker
              class="form-control mb-2"
              placeholder="From"
              [(ngModel)]="chartFromDate"
              [minDate]="minDate || undefined"
              [maxDate]="chartToDate ? chartToDate : currentDate"
              readonly
              (keydown)="preventInput($event)"
              (bsValueChange)="onStartChartDatePickerChange($event)"
              [bsConfig]="chartDatePicheConfig"
            />
          </div>
          <div class="filter-item">
            <label class="col-form-label">To</label>
            <input
              type="text"
              class="form-control"
              bsDatepicker
              placeholder="To"
              [(ngModel)]="chartToDate"
              [minDate]="chartFromDate || undefined"
              [maxDate]="currentDate"
              readonly
              (keydown)="preventInput($event)"
              (bsValueChange)="onEndChartDatePickerChange($event)"
              [bsConfig]="chartDatePicheConfig"
            />
          </div>
          }
        </div>
        } @else {
        <div class="mx-auto d-table">
          <div class="filter-item">
            <strong>Please select device to see the consumption graph.</strong>
          </div>
        </div>
        }
      </div>
      <div class="text-left">
        <div id="chart"></div>
      </div>
    </div>
  </div>
</div>
